
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import formatOdds from '../../../../utils/formatOdds';
import '../NumberBet.scss';
import NumberBetContext from '../Context/NumberBet.context';
import CombinationsModal from 'src/components/NumbersBetting/LottoSummary/CombinationsModal/CombinationsModal';
import NumberBetDetails from './BetDetails/NumberBetDetails';
import NumberBetStakes from './BetStakes/NumberBetStakes';
import BallsContainer from './BallsContainer/BallsContainer';
import { RootState } from 'src/configs/store';
import Icon from 'src/components/Icon/Icon';
import classNames from 'classnames';

interface NumberBetProps {
  index: number,
  allowStakes?: boolean,
  totalCombinations: number
  hideProfit: boolean
}

function ComboBet({ index, totalCombinations, allowStakes = true, hideProfit }: NumberBetProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    amount,
    banker,
    validMessage,
    selectedOddsType,
    showCombinableWarning,
    onAmountChange,
    handleUpdate,
    changePermutations,
    singleBet,
    selectedSlip,
    stake,
    showCombinations,
    setShowCombinations,
    combinations
  } = useContext(NumberBetContext);

  const bet = singleBet;
  const isSuspended = +bet.marketStatusNumber === 3 || +bet.outcomeStatusNumber === 3;
  const { divisor, singleSlip } =useSelector((state: RootState) => state.betslip);
  const suspendedName = +bet.marketStatusNumber === 3 ? bet.marketStatusName : bet.outcomeStatusName;

  return (
    <>
      <NumberBetDetails
        marketName={ bet.marketName }
        outcome={ bet.startNo ? `${ bet.startNo }. ${ bet.outcome }` : bet.outcome || bet.outcomeName }
        odds={ formatOdds(bet.odds, selectedOddsType) }
        index= { index }
        totalCombinations= { +totalCombinations }
        isSuspended={ isSuspended }
        selectedSlip = { selectedSlip }
        banker={ banker }
        selectedNumbers={ bet.selectedNumbers }
        permutationsCount= { bet.permutationsCount }
        oddsChanged={ bet.oddsChanged }
        sameBallset={ bet.sameBallSet }
      />
      <div className="numberbet-details__balls-container">
        <BallsContainer anyNumbers={ bet.selectedNumbers } sameBallset={ bet.sameBallSet } />
        {
          bet.permutationsCount && bet.permutationsCount > 1 &&
         <span className="numberbet-details__combo" onClick={ changePermutations }>{ `${ t('betslip.combo') }: ${ bet.permutationsCount }` }</span>
        }
      </div>
      {
        !hideProfit &&
        <NumberBetStakes
          validMessage ={ validMessage }
          allowStakes={ allowStakes }
          amount={ amount }
          maximumProfit={ stake && stake.maximumProfit ? stake.maximumProfit : '0.00' }
          onAmountChange={ onAmountChange }
          divisor={ divisor }
          permutationsCount={ bet.permutationsCount }
          marketStatusNumber={ +bet.marketStatusNumber }
          marketStatusName={ bet.marketStatusName }
          outcomeStatusNumber={ +bet.outcomeStatusNumber }
          outcomeStatusName={ bet.outcomeStatusName }
          combinationExclusions={ bet.combinationExclusions }
          index={ index }
          perBet={ stake?.singleStake || null }
          showCombinableWarning={ showCombinableWarning }
          handleUpdate={ handleUpdate }
        />
      }
      {
        hideProfit &&
          <div className={
            classNames({
              'numberbet-stakes numberbet-stakes--no-profit': true,
              'numberbet-stakes--warning': showCombinableWarning || validMessage !== '' || isSuspended
            })
          }
          >
            <div className="bet-stakes__stake-container">
              {
                validMessage !== '' && singleSlip.stakeSelection === 'differentStake' &&(
                  <Icon icon="warningFilled" className="bet-stakes__warning-icon" />
                )
              }
            </div>
            {
              validMessage !== '' && singleSlip.stakeSelection === 'differentStake' &&(
                <div className="bet-stakes__minimum-warning"><span>
                  { validMessage }
                </span>
                <div onClick={ handleUpdate } className="bet-stakes__update">Update</div>
                </div>
              )
            }
            {
              showCombinableWarning && (
                <div className="bet-stakes__combinable">{ t('betslip.notCombinable') } { bet.combinationExclusions.toString() }</div>
              )
            }
            {
              isSuspended &&<div className="bet-stakes__suspended">
                <span>{ t('betslip.marketSuspended') }</span>
                <span>{ suspendedName }</span>
                <button
                  onClick={ () => dispatch.betslip.removeBetAtIndex(index) }
                  className="bet-stakes__btn-remove"
                >{ t('betslip.removeBet') }</button>
              </div>
            }
          </div>
      }
      {
        showCombinations && (
          <>
            <CombinationsModal
              title={ t('numbers.combinations') }
              permutations={ combinations.permutations }
              stake={ combinations.singleStake }
              profit={ combinations.prediction.minimumReturn }
              permutations2={ combinations.prediction?.permutations2 }
              odds={ combinations.odds }
              onClick={ () => setShowCombinations(!showCombinations) }
            />
          </>
        )
      }
    </>
  );
}

export default ComboBet;
